import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { Globals } from '../../globals';
import { HttpParams, HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

interface Delibery_note {
  UID: string;
  UID_RESTAURANT: string;
  bill_static: string;
  date: any;
  number: string;
  provider_static: string;
  uid_bill: string;
  uid_provider: string;
  values: object;
  state?: string; // Estado del albarán: 'draft', 'completed', etc.
}

interface Ingredient {
  UID: string;
  UID_RESTAURANT: string;
  allergens: object;
  measurement: string;
  name: string;
  price_static: number;
  provider_static: string;
  providers: object;
  stock: number;
  stock_alert: number;
  sub_recipe: boolean;
  tags: object;
  tags_static: string;
  tax: number;
  foodcost: object;
  real_weight: number;
  recipe: string;
  time: string;
  tools: string;
  image: string;

}

interface Product {
  UID: string;
  UID_RESTAURANT: string;
  allergens: object;
  measurement: string;
  name: string;
  price_static: number;
  provider_static: string;
  providers: object;
  stock: number;
  stock_alert: number;
  sub_recipe: boolean;
  tags: object;
  tags_static: string;
  tax: number;
  foodcost: object;
  real_weight: number;
  recipe: string;
  time: string;
  tools: string;
  image: string;
  pvp: number;
}

interface List {
  UID: string;
  UID_RESTAURANT: string;
  allergens: object;
  measurement: string;
  name: string;
  price_static: number;
  provider_static: string;
  providers: object;
  stock: number;
  stock_alert: number;
  sub_recipe: boolean;
  tags: object;
  tags_static: string;
  tax: number;
  foodcost: object;
  real_weight: number;
  recipe: string;
  time: string;
  tools: string;
  image: string;
  pvp: number;
  type: string;
  values: object;
}


@Injectable()
export class DeliberyNoteServices {
  private firestore: any;

  deliberyNoteCol: AngularFirestoreCollection<Delibery_note>;
  deliberyNoteDoc: AngularFirestoreDocument<Delibery_note>;
  delibery_notes: Observable<Delibery_note[]>;
  delibery_notes_stock: Observable<Delibery_note[]>;

  ingredientsCol: AngularFirestoreCollection<Ingredient>;
  ingredientsCol_subrecipe: AngularFirestoreCollection<Ingredient>;
  ingredients: Observable<Ingredient[]>;

  productCol: AngularFirestoreCollection<Product>;
  products: Observable<Product[]>;
  productDoc: AngularFirestoreDocument<Product>;

  listing: Observable<List[]>;
  listprod: Observable<List[]>;
  //list: Observable<List[]>;

  public list_array_tmp = Array();
  public liststockmax_array_tmp = Array();
  public liststockmin_array_tmp = Array();
  public prodings_array_tmp = Array();
  public uid_provider_selected: any;
  public delibery_notes_array_tmp = Array();
  public pagesIngredientsProducts: any;
  public page_active: number = 1;
  public limit_pages = 100;
  public first_element_name: any;
  public get_ingredients_products_done: boolean = false;
  public products_ingredients_array: any;
  public pagesDelibery: any;
  public delibery_array: any;
  public delibery_first_element_array: any;
  public list_delibery_notes: any;
  public get_delibery_done: boolean = false;
  public total_delibery_notes: number = 0;
  public latestDeliveryNote: any = null;
  private latestDeliveryNoteSubject = new BehaviorSubject<any>(null);
  public latestDeliveryNote$ = this.latestDeliveryNoteSubject.asObservable();

  private deliveryNoteUpdated = new BehaviorSubject<boolean>(false);
  public deliveryNoteUpdated$ = this.deliveryNoteUpdated.asObservable();

  // Campos para evitar duplicados
  public currentDraftDeliveryNote: string | null = null;
  public currentCreationMethod: 'manual' | 'ia' | null = null;

  constructor(public afs: AngularFirestore,
    public globals: Globals,
    public http: HttpClient) {
    this.firestore = firebase.firestore();
  }

  notifyDeliveryNoteUpdated() {
    this.deliveryNoteUpdated.next(true);
  }

  // Método para limpiar el estado de sesión activa
  clearCurrentDraft() {
    this.currentDraftDeliveryNote = null;
    this.currentCreationMethod = null;
  }

  setLatestDeliveryNote(updatedNote: any) {
    this.latestDeliveryNoteSubject.next(updatedNote);
  }

  async getLatestDeliveryNote(updatedNote?: any) {
    try {
      if (updatedNote) {
        // Ensure correct date format
        updatedNote.date = updatedNote.date instanceof Date
          ? updatedNote.date
          : updatedNote.date.toDate
            ? updatedNote.date.toDate()
            : new Date(updatedNote.date);

        this.setLatestDeliveryNote(updatedNote);
        return updatedNote;
      }

      // If we already have an updated note, return it without fetching
      if (this.latestDeliveryNoteSubject.getValue()) {
        return this.latestDeliveryNoteSubject.getValue();
      }

      const latestNoteSnapshot = await firebase.firestore()
        .collection('delibery_note')
        .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
        .orderBy('date', 'desc')
        .limit(1)
        .get({ source: 'server' });

      if (!latestNoteSnapshot.empty) {
        const latestNote = latestNoteSnapshot.docs[0].data();

        latestNote.date = latestNote.date.toDate ? latestNote.date.toDate() : new Date(latestNote.date);

        this.setLatestDeliveryNote(latestNote);
        return latestNote;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  getListDeliberyNotes(UID_RESTAURANT) {
    this.deliberyNoteCol = this.afs.collection('delibery_note', ref =>
      ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
        .orderBy('date', 'desc')
    );
    this.delibery_notes = this.deliberyNoteCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Delibery_note;
        data.UID = a.payload.doc.id;
        return data;
      }).filter(deno => {
        // Excluir SOLO albaranes en estado 'draft'
        // Normalizar para evitar problemas de case sensitivity o espacios
        return deno.state && deno.state.toString().toLowerCase().trim() === 'draft' ? false : true;
      });
    });
  }

  /*GET IN STOCK*/
  getListDeliberyNotesBasic(UID_RESTAURANT) {
    this.deliberyNoteCol = this.afs.collection('delibery_note', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('date', 'desc'));
    this.delibery_notes_stock = this.deliberyNoteCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Delibery_note;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  /*GET INGS/PRODS*/
  // ✅ Subscriptions para getListPartialSelect
  private listingSubscription: any;
  private listprodSubscription: any;
  getListPartialSelect(UID_RESTAURANT) {
    // ✅ LIMPIAR SOLO los arrays que se usan en esta función
    this.list_array_tmp = [];

    // ✅ Limpiar subscriptions anteriores si existen
    if (this.listingSubscription) {
      this.listingSubscription.unsubscribe();
    }
    if (this.listprodSubscription) {
      this.listprodSubscription.unsubscribe();
    }

    this.ingredientsCol = this.afs.collection('ingredients', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('sub_recipe', '==', false)
      .orderBy('name', 'asc'));
    this.listing = this.ingredientsCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as List;
        data.UID = a.payload.doc.id;
        data.type = "ingredient";

        return data;
      });
    });

    // Guardar referencia a la suscripción para poder cancelarla después
    this.listingSubscription = this.listing.subscribe(docs => {
      // Limpiar array antes de agregar nuevos elementos para evitar duplicados
      // Filtrar solo ingredientes del array actual
      this.list_array_tmp = this.list_array_tmp.filter(item => item.type !== 'ingredient');

      docs.forEach(doc => {
        this.list_array_tmp.push(doc);
      })
    });


    this.productCol = this.afs.collection('products', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('sub_recipe', '==', false)
      .orderBy('name', 'asc'));
    this.listprod = this.productCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as List;
        data.UID = a.payload.doc.id;
        data.type = "product";

        return data;
      });
    });

    // Guardar referencia a la suscripción para poder cancelarla después
    this.listprodSubscription = this.listprod.subscribe(docs => {
      // Limpiar productos del array antes de agregar nuevos para evitar duplicados
      this.list_array_tmp = this.list_array_tmp.filter(item => item.type !== 'product');

      docs.forEach(doc => {
        this.list_array_tmp.push(doc);
      })
    });

  }


  delete(uid) {
    this.afs.doc('delibery_note/' + uid).delete();
  }

  calculatePrice(price, total_quantity, measurement) {
    var price_ingr;
    if (measurement === 'kg' || measurement === 'l') {
      //kg l
      //var price_grams = price / 1000;
      //price_ingr = price_grams * total_quantity;
      price_ingr = price * total_quantity;
    } else {
      //units
      price_ingr = price * total_quantity;
    }
    return price_ingr;
  }

  async getListDeno(UID_RESTAURANT) {
    const denoRef = this.firestore.collection('delibery_note');

    var denos = [];

    await denoRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('uid_provider', '==', this.uid_provider_selected)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          var deno = doc.data();
          deno.UID = doc.id;
          var total = 0;

          //mirem si esta obert o no existeix el state
          if (deno.state == 'open' || deno.state == undefined) {
            //calculem total de l'alabra
            if (deno.list != undefined || deno.list != null) {
              deno.list.forEach(function (value) {
                total += value.total
              });
            }

            //push a array
            deno.total = total;
            denos.push(deno);
          }

        });
      });

    //ordenem per data
    denos.sort((a, b) => (new Date(a.date) < new Date(b.date)) ? 1 : ((new Date(b.date) < new Date(a.date)) ? -1 : 0));
    return denos;
  }


  async deleteDeliberyNotes(list) {
    //
    for (let deno of list) {
      await this.afs.collection('delibery_note').doc(deno[0]).update({
        'state': 'closed',
      }).then(() => { });
    }
  }

  async getDeno(uid) {
    const denoRef = this.firestore.collection('delibery_note').doc(uid);

    var _deno;

    await denoRef.get().then(doc => {
      _deno = doc.data();
      _deno.UID = doc.id;
    })

    return _deno;

  }

  //FILTER
  public filteredProductsIngredients: any;
  public filteredProductsIngredientsActive: boolean = false;
  searchProductsIngredientsNode(value) {
    if (value.target.value == '' || value.target.value == undefined) {
      this.filteredProductsIngredientsActive = false;
    } else {
      if (value.target.value.length >= 3) {
        const params = new HttpParams()
          .set('uid', this.globals.restaurant_uid)
          .set('filter_string', value.target.value.toLowerCase());
        this.http.post(this.globals.analytics_path + 'filter/ingredients_products', params, {})
          .subscribe(async res => {
            this.filteredProductsIngredients = res;
            this.filteredProductsIngredientsActive = true;
          });
      } else {
        this.filteredProductsIngredientsActive = false;
      }
    }
  }
  //PAGINATE
  async getPagesIngredientsProducts(elements_per_page) {
    this.get_ingredients_products_done = false;
    this.filteredProductsIngredientsActive = false;
    this.limit_pages = elements_per_page;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('elements_per_page', elements_per_page);
    await this.http.post(this.globals.analytics_path + 'paginate/ingredients_products', params, {})
      .subscribe(async res => {
        this.pagesIngredientsProducts = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
        this.list_array_tmp = res['list'];
        if (this.pagesIngredientsProducts != 0) {
          this.getListIngredientsProductsMinMax();
        } else {
          this.filteredProductsIngredientsActive = true;
        }
      });
  }
  getListIngredientsProductsMinMax() {
    this.get_ingredients_products_done = true;
    //Search for first element to start
    this.first_element_name = (this.page_active - 1) * this.limit_pages;
    //We slice the array with the first element, and the first element plus the limit to get the last index
    if (this.limit_pages > 0) {
      this.products_ingredients_array = this.list_array_tmp.slice(this.first_element_name, this.first_element_name + this.limit_pages);
    } else {
      this.products_ingredients_array = this.list_array_tmp;
    }
  }

  deno_array_tmp: any = [];
  list_deno_array: any = [];
  deno_array_filtered: any = [];
  deno_searchbar_text: any = '';

  async getPagesDelibery(loader, date_first, date_last) {
    this.get_delibery_done = loader;

    // ✅ LIMPIAR SOLO los arrays que se usan DENTRO de esta función
    this.deno_array_tmp = [];
    this.deno_array_filtered = [];
    this.total_delibery_notes = 0;

    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('datetime_init', date_first)
      .set('datetime_final', date_last);
    await this.http.post(this.globals.analytics_path + 'paginate/delibery_notes', params, {})
      .subscribe(async res => {
        this.deno_array_tmp = res['list_delibery_notes'];
        this.total_delibery_notes = res['total'];
        if (this.deno_array_tmp.length != 0) {
          this.getListDeliberyMinMax();
        } else {
          this.deno_array_filtered = this.deno_array_tmp;
          this.get_delibery_done = true;
        }
      });
  }

  getListDeliberyMinMax() {
    this.get_delibery_done = true;
    
    // Filtrar SOLO albaranes en estado 'draft' (ocultar borradores)
    // Normalizar para evitar problemas de case sensitivity o espacios
    this.deno_array_tmp = this.deno_array_tmp.filter(deno => {
      return deno.state && deno.state.toString().toLowerCase().trim() === 'draft' ? false : true;
    });
    
    //Ordenamos el array
    this.deno_array_tmp.sort((a, b) => this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b)));
    //For para poner en activo los platos que puede ver el free.
    this.list_deno_array = this.deno_array_tmp;
    this.deno_array_filtered = this.deno_array_tmp;
    this.denoSearch(this.deno_searchbar_text);
  }

  denoSearch(value) {
    if (value) {
      this.deno_array_filtered = this.list_deno_array.filter(objeto => {
        return this.globals.objectToArray(objeto).some(valor => {
          if (typeof valor === 'string' || typeof valor === 'number') {
            // Comparar como string
            return valor.toString().toLowerCase().includes(value.toLowerCase());
          } else if (Array.isArray(valor)) {
            // Buscar en cada elemento del array
            return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
          }
          return false;
        });
      });
    } else {
      this.deno_array_filtered = this.list_deno_array;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/delibery_note/services.ts